<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Бизнес-ланчи</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="container">
            <div class="bottom-wrapper">
              <div class="line"></div>
              <p style="margin-top:2%;">Закажите бизнес ланч в офис на сервисе доставки еды  <router-link to="/">хочу-поесть.рф</router-link>.</p>
              <p>В жизни мы часто сталкиваемся с такими понятиями как комплексные обеды, бизнес ланчи. Если вы слышите об этом впервые, то обязательно зайдите на наш сайт и попробуйте сами. Заказать еду онлайн можно легко и быстро. Деловой обед, бизнес ланч – все для того, чтобы деловой человек не терял свое время на выбор блюд.</p>
              <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/lunch1.jpg" alt="Бизнес-ланчи" width="700" /></center></p>
              <p style="margin-top:2%;">Заказать бизнес ланч можно на нашем сайте <router-link to="/">хочу-поесть.рф</router-link> быстро и просто.</p>
              <p>Бизнес ланчи с доставкой от нашего агрегатора сэкономит вам время, а скорость доставки позволит насладиться горячим обедом.</p>
              <p>Деловым людям некогда стоять у плиты и готовить себе еду на неделю вперед, поэтому вы можете оформить подписку на доставку еды и существенно сэкономить свое время.</p>
              <router-link :to="'/product/9'" tag="div">
                <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'lunch'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/lunch.vue